import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";
import IpoBaseServerWrapper from "../IpoBase/IpoBaseServerWrapper";
import IpoClient from "./IpoClient";

const IpoServer = async (authoringData: IpoAuthoringDataType = {}) => {
  return (
    <IpoBaseServerWrapper
      authoringData={authoringData}
      defaultIpoType="upcoming"
      renderClient={(mainboardInitial, smeInitial) => (
        <IpoClient
          mainboardInitial={mainboardInitial}
          smeInitial={smeInitial}
          authoringData={authoringData}
        />
      )}
    />
  );
};

export default IpoServer;
